<script setup lang="ts">
import { Toaster } from '@eci-saas/ui'
import en_US from '@eci-saas/ui/locale/en_US'
import zh_CN from '@eci-saas/ui/locale/zh_CN'
import { useThemeStore } from './stores/theme'

const { isDark, color } = storeToRefs(useThemeStore())

const { locale: i18nLocale } = useI18n()
const locale = computed(() => {
  return i18nLocale.value === 'zh-CN' ? zh_CN : en_US
})
</script>

<template>
  <ConfigProvider :locale="locale">
    <div class="h-full" :class="{ 'dark': isDark, 'theme-gold': color === 'gold', 'theme-indigo': color === 'indigo' }">
      <Toaster :theme="isDark ? 'dark' : 'light'" rich-colors />
      <RouterView />
    </div>
  </ConfigProvider>
</template>
